import React, { Component } from 'react';
import Thumbnail from 'components/common/Thumbnail';
import Tiltable from 'components/common/Tiltable';
import WithTooltip from 'components/common/WithTooltip';
import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css';

const TiltableThumbWithTooltip = WithTooltip( Tiltable( Thumbnail) );
const WHEEL_MULTIPLIER = 0.5;

class Panel extends Component {
	constructor(props) {
		super(props);
		this.widthDiff = 0;
		this.panel = React.createRef();
		this.swiperContainer = React.createRef();
		this.pane = React.createRef();
		this.swiper = null;
	}
	componentDidMount() {
		window.addEventListener('resize', this.recalc);
		this.recalc();
	}
	componentDidUpdate() {
		this.recalc();
	}
	recalc = () => {
		const container_W = this.swiperContainer.current.clientWidth;
		const pane_W = this.pane.current.clientWidth;
		const widthDiff = pane_W - container_W;
		this.widthDiff = widthDiff;

		if ( widthDiff > 0 ) {
			if (!this.swiper) {
				this.swiper = new Swiper(this.swiperContainer.current, { slidesPerView: 'auto', keyboard: true, });
				this.panel.current.addEventListener('mousewheel', this.setTranslate);
			}
			this.setTranslate();
		} else {
			if ( this.swiper ) this.destroySwiper();
			this.setTranslate();
		}
	}
	setTranslate = (e) => {
		if (e) e.preventDefault();

		let newT;
		if ( this.swiper ) {
			const currentT = this.swiper.translate;
			newT = e ? currentT - (e.deltaY * WHEEL_MULTIPLIER) : currentT;
			if ( newT > 0 ) newT = 0;
			if ( newT < -this.widthDiff ) newT = -this.widthDiff;
			this.swiper.setTranslate(newT);
		} else {
			newT = -this.widthDiff / 2;
			this.pane.current.style.transform = `translate3d(${newT}px, 0, 0)`;
		}
	}
	destroySwiper = () => {
		this.swiper.destroy( true, false );
		this.swiper = null;
		this.panel.current.removeEventListener('mousewheel', this.setTranslate);
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.recalc);
		if ( this.swiper ) this.destroySwiper();
	}
	render() {
		let slides;
		if (this.props.items) {
			const slideStyle = { height: 'inherit' };
			slides = this.props.items.map( (item, index) => {
				const tooltip = item.title + ' ' + item.row2;
				return (
					<div className="swiper-slide"
						style={slideStyle} 
						key={item.slug}>
						<TiltableThumbWithTooltip {...item} tooltip={tooltip} />
					</div>
				)
			});
		}
		const panelStyle = {
			position: 'fixed',
			top: 0, left: 0, 
			width: '100%', height: '100%',
		}
		const innerStyle = {
			height: '100%',
		}
		const swiperContainerStyle = {
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			overflow: 'visible',
		};
		const swiperWrapperStyle = {
			height: 'auto', width: 'auto',
			alignItems: 'flex-end',
		};
		return (
			<div className="Panel" ref={this.panel} style={panelStyle}>
				<div className="Panel-inner" style={innerStyle}>
					<div className="swiper-container" ref={this.swiperContainer} style={swiperContainerStyle}>
						<div className="swiper-wrapper" ref={this.pane} style={swiperWrapperStyle}>
							{slides}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Panel;


// WEBPACK FOOTER //
// ./src/components/Pages/Curated/Panel.jsx